import Aws from '@components/Aws';
import Button from '@components/Button';
import { BannerType } from '@data/types';
import useStore from '@store/store';
import classNames from 'classnames';
import React from 'react';

interface Props extends BannerType {
  as?: keyof JSX.IntrinsicElements;
}

const Banner: React.FC<Props> = ({
  as: Component = 'div',
  htmlContent,
  button,
  video,
}) => {
  const { setPage } = useStore();

  return (
    <Component
      className={classNames(
        'w-full h-screen bg-gradient-to-t from-5% from-blue to-red-dark relative',
        [video ? 'max-h-[555px]' : 'max-h-[280px]']
      )}
    >
      {video && (
        <video
          className="absolute inset-0 w-full h-full object-cover"
          src={require('@assets/videos/banner.mp4')}
          autoPlay
          loop
          muted
          playsInline
        />
      )}
      <div className="px-4 py-6 xl:px-0 md:py-8 w-full max-w-outerGrid h-full flex justify-center items-center flex-col mx-auto relative">
        <div className="mt-auto flex flex-col items-center">
          <div
            className="prose prose-h1:mb-0 prose-h1:font-lightNormal prose-h1:text-[2.37rem] prose-h1:md:text-[2.62rem] prose-h1:text-white prose-h2:text-white prose-h2:my-2 prose-h2:font-lighterNormal prose-h2:text-[2.37rem] prose-h2:md:text-[2.62rem] prose-h2:leading-tight text-center prose-h2:mt-0"
            dangerouslySetInnerHTML={
              htmlContent ? { __html: htmlContent } : undefined
            }
          ></div>
          {button && (
            <Button
              {...button}
              type="button"
              onClick={() => {
                window.scrollTo(0, 0);
                setPage('the_assessment');
              }}
            />
          )}
        </div>
        <Aws />
      </div>
    </Component>
  );
};

export default Banner;
